import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  MeetingEmailTemplateRequest,
  MeetingEmailTemplateResponse,
  MeetingSystemEmailTemplateResponse,
  PageResponse,
} from '../models/meeting.model';
import { AvailableVariableNamespace } from '../../templates/models/template.model';

@Injectable({ providedIn: 'root' })
export class MeetingEmailTemplateApiService {
  private url = `${environment.apiUrl}api/meeting-email-templates`;
  constructor(private http: HttpClient) {}

  list(
    businessId: number,
    page = 0,
    size = 20
  ): Observable<PageResponse<MeetingEmailTemplateResponse>> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<MeetingEmailTemplateResponse>>(this.url, {
      params,
    });
  }

  listByType(
    businessId: number,
    templateType: string
  ): Observable<MeetingEmailTemplateResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('templateType', templateType);
    return this.http.get<MeetingEmailTemplateResponse[]>(`${this.url}/by-type`, {
      params,
    });
  }

  /**
   * INC 81 — plantillas predeterminadas DEL SISTEMA (solo lectura). Es el correo que sale
   * cuando el negocio no ha marcado ninguna propia como predeterminada. No tienen id: no se
   * pueden editar ni eliminar.
   */
  listSystemDefaults(): Observable<MeetingSystemEmailTemplateResponse[]> {
    return this.http.get<MeetingSystemEmailTemplateResponse[]>(`${this.url}/system-defaults`);
  }

  getById(
    id: number,
    businessId: number
  ): Observable<MeetingEmailTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingEmailTemplateResponse>(`${this.url}/${id}`, {
      params,
    });
  }

  create(
    body: MeetingEmailTemplateRequest
  ): Observable<MeetingEmailTemplateResponse> {
    return this.http.post<MeetingEmailTemplateResponse>(this.url, body);
  }

  update(
    id: number,
    businessId: number,
    body: MeetingEmailTemplateRequest
  ): Observable<MeetingEmailTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<MeetingEmailTemplateResponse>(
      `${this.url}/${id}`,
      body,
      { params }
    );
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.url}/${id}`, { params });
  }

  /**
   * INC 65 — merge tags que el renderizador de reuniones SÍ sustituye al enviar
   * (fecha, hora, enlace, lugar, organizador, contacto…). No usar el catálogo de
   * `/api/templates/available-variables`: ese es el de marketing y sus variables
   * no se resuelven en este flujo.
   */
  getVariables(): Observable<AvailableVariableNamespace[]> {
    return this.http.get<AvailableVariableNamespace[]>(`${this.url}/variables`);
  }
}
